import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Container, Row, Col } from "react-bootstrap";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import StudentAttendanceHome from '../components/student_attendance/StudentAttendanceHome';
import { canView } from "../../utils/modulePermissions";
import {
  getAuthorizedBranchIds,
  getAuthorizedClassIds,
  getAuthorizedSectionIds,
} from "../utils/authHelper";
import axios from 'axios';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";

// /student/attendance → "Student_Attendance". See the note in StudentAttendanceHome:
// this route has no MODULE_ROUTES entry, so the component's own guard enforces it.
const STUDENT_ATTENDANCE_MODULE = ["Student_Attendance"];
const skipUnlessViewable = () => !canView(STUDENT_ATTENDANCE_MODULE);

const FETCH_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
        }
    }
`;

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
        getAcademicYears(id: $id) {
            id
            academic_year
        }
    }
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;


class StudentAttendance extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {

    // Your API endpoint
    const apiUrl = 'https://wapi.rizee.in/webhook';

    axios.post(apiUrl, {})
      .then(response => {
        console.log("response", response)
      })
      .catch(err => {
        // Handle errors
        console.log("error");
      });

    axios.post(apiUrl, {}, {
      headers: {
        'Content-Type': 'application/json',
        // Add any other required headers here
      },
    })
      .then(response => {
        console.log("response", response);
      })
      .catch(error => {
        // Handle errors
        console.log("error", error);
      });

    // When the queries are skipped (is_view === 0) react-apollo passes no data props at
    // all, so default them — every `.error` / `.loading` read below would otherwise throw
    // on undefined. StudentAttendanceHome renders Access Denied in that case.
    const {
      getBranches = {},
      getAcademicYearsQuery = {},
      getExamClasses = {},
      getStreamsQuery = {}
    } = this.props;

    // LOADING
    // if (
    // getBranches.loading ||
    // getAcademicYearsQuery.loading ||
    // getExamClasses.loading
    // ) {
    //   return <Preloader />;
    // }

    // ERROR
    if (
      getBranches.error ||
      getAcademicYearsQuery.error ||
      getExamClasses.error ||
      (getStreamsQuery && getStreamsQuery.error)
    ) {
      return <h5>Error loading data</h5>;
    }

    let authorizedBranches = getBranches.getBranches || [];
    const authorizedIds = getAuthorizedBranchIds();
    const authorizedClassIds = getAuthorizedClassIds();
    const authorizedSectionIds = getAuthorizedSectionIds();

    if (authorizedIds.length) {
      authorizedBranches = authorizedBranches.filter((b) => authorizedIds.includes(String(b.id)));
    }

    authorizedBranches = authorizedBranches.map((b) => {
      let sec = b.sections || [];
      if (authorizedClassIds.length) {
        sec = sec.filter((s) => authorizedClassIds.includes(String(s.class_id)));
      }
      if (authorizedSectionIds.length) {
        sec = sec.filter((s) => authorizedSectionIds.includes(String(s.id)));
      }
      return { ...b, sections: sec };
    });


    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />

        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>

          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>

              {
                getBranches.loading ||
                  getAcademicYearsQuery.loading ||
                  getExamClasses.loading ||
                  (getStreamsQuery && getStreamsQuery.loading) ?
                  (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh", width: "100%" }}>
                      <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  )
                  :
                  (
                    <StudentAttendanceHome
                      branches={
                        authorizedBranches
                      }
                      academicYears={
                        getAcademicYearsQuery.getAcademicYears || []
                      }
                      classes={
                        getExamClasses.getExamClasses || []
                      }
                      streams={
                        (getStreamsQuery && getStreamsQuery.getStreams) || []
                      }
                    />
                  )
              }


            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
// skip on all four: they are READ queries and there are no mutations here, so is_view === 0
// fetches nothing at all rather than filling the Apollo cache behind the Access Denied card.
export default withRouter(withApollo(
  compose(
    graphql(FETCH_BRANCHES,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          },
          fetchPolicy: 'network-only'
        }),
        skip: skipUnlessViewable,
        name: "getBranches"
      }),
    graphql(GET_ACADEMIC_YEARS, {
      name: "getAcademicYearsQuery",
      options: { variables: { id: 1 } },
      fetchPolicy: "network-only",
      skip: skipUnlessViewable,
    }),
    graphql(GET_CLASSES, {
      name: "getExamClasses",
      options: { variables: { id: 1 } },
      fetchPolicy: "network-only",
      skip: skipUnlessViewable,
    }),
    graphql(GET_STREAMS, {
      name: "getStreamsQuery",
      options: { fetchPolicy: "network-only" },
      skip: skipUnlessViewable,
    }),
  )(StudentAttendance))
);
